export const themeOptions = {
  typography: {
    fontFamily: ['"Noto Sans JP"', "-apple-system", "BlinkMacSystemFont", "sans-serif"].join(","),
  },
};